import React, {FC} from 'react';
import styled from 'styled-components';

import {ViewerPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {boxShadow} from '../../../../../../libs/shared/ui/src/theme/themeStyleHelpers';
import {SynopsisCellHeaderContainer} from './synopsisCellHeaderContainer';
import {SynopsisMessageItem} from './synopsisHelpers';
import {SynopsisMessageDetailPreview} from './synopsisMessageDetailPreview';
import {useSynopsisViewerContext} from './synopsisViewerContext';

interface SynopsisMessagePreviewProps {
  item: SynopsisMessageItem;
  isFollowUp?: boolean;
  panelId: ViewerPanelId;
}

const StyledCellDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  border-radius: 12px;
  background-color: ${(p) => p.theme.message.background};
  ${(p) => boxShadow(p.theme, '0px 1px 9px 0px rgba(0, 0, 0, 0.08)')};
`;

export const SynopsisMessagePreview: FC<SynopsisMessagePreviewProps> = ({item, isFollowUp, panelId}) => {
  const {namespace} = useSynopsisViewerContext();
  const {timestamp, authorId, contactUid, aiSubject} = item;

  const teammateIds = authorId ? [authorId] : undefined;

  return (
    <StyledCellDiv>
      {!isFollowUp && (
        <SynopsisCellHeaderContainer
          teammateIds={teammateIds}
          contactUid={contactUid}
          aiSubject={aiSubject}
          namespace={namespace}
          timestamp={timestamp}
          panelId={panelId}
        />
      )}
      {item.details.map((detail) => (
        <SynopsisMessageDetailPreview
          key={detail.id}
          detail={detail}
          isFollowUp={isFollowUp}
          panelId={panelId}
        />
      ))}
    </StyledCellDiv>
  );
};
